import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentProductos } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductService {
    constructor(private http: HttpClient) { }

    getProductsUserID(idUser) {
        let json = {
            userID: idUser,
            ApplicationID:0
        }
        console.log("json a get de productos",json)
        return this.http.post<any>(`${environmentProductos.apiUrl}/Product/GetByFilter`,json);
    }

    getProductID(idUser,idApplication){
        let json ={
            UserID:idUser,
	        ApplicationID:idApplication
        }
        console.log(json)
        return this.http.post<any>(`${environmentProductos.apiUrl}/Product/GetByFilter`,json );
    }

    insertProduct(json,estado) {
        return this.http.post<any>(`${environmentProductos.apiUrl}/Product/InsertOrUpdate`,json );
    }

    validate(json){
        console.log("ruta",`${environmentProductos.apiUrl}/Product/ValidateProduct`)
        return this.http.post<any>(`${environmentProductos.apiUrl}/Product/ValidateProduct`,json );
    }

    getTypes() {
        return this.http.get<any>(`${environmentProductos.apiUrlHelpDesk}/api/ticket`);
    }

    insertConsult(json) {
        return this.http.post<any>(`${environmentProductos.apiUrlHelpDesk}/api/ticket`,json );
    }
}